import React from 'react';
import './HealthcarePartner.css';
import { useTranslation } from 'react-i18next';

const HealthcarePartner: React.FC = () => {
  const { t } = useTranslation();
  const stats = t('healthcarePartner.stats', { returnObjects: true }) as string[];

  return (
    <section className="healthcare-partner">
      <div className="container">
        <div className="partner-header">
          <h2>{t('healthcarePartner.title')}</h2>
        </div>
        
        <div className="partner-content">
          <div className="partner-text">
            <h3>{t('healthcarePartner.subtitle')}</h3>
            <p>{t('healthcarePartner.description')}</p>
            <div className="stats">
              {["500+", "20K+", "10K+", "24/7"].map((number, i) => (
                <div key={i} className="stat-item">
                  <span className="stat-number gr-title-2">{number}</span>
                  <span className="stat-label">{stats[i]}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="partner-image">
            <img 
              src="/images/rand3.jpg" 
              alt={t('healthcarePartner.alt')} 
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HealthcarePartner;
